import React, { useContext, useState, useEffect } from 'react';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import { useTranslation } from 'next-i18next';
import { HeaderContext } from '@contexts/HeaderContext';
import DropdownButton from '../Header/DropDownContainer';
import {
    browserItems, footerInfoList, gotoInfoPageAction, InfoPageActionStrategy,
} from './constants';
import SiteMapping from '../../configs/siteMapping';
import ServerPath from '../../configs/serverPath';
import ErrorBoundary from '../common/ErrorBoundary';
import GameLicense from './GameLicense';
import Footer3rdPartyProvider from './Footer3rdPartyProvider';
import FootText from './FooterText';
import { DomainWithLicenseList } from './constants';

const handleGoToInfoPageClick = (language, infoPage, openType, composePath, isAutoColorSchemeShow) => {
    let fileLanguage = language;
    if (language === 'zhcn') {
        fileLanguage = 'cs';
    }
    const strategy = {
        1: InfoPageActionStrategy.OpenStaticPage,
        2: InfoPageActionStrategy.OpenExternalSite,
    }[openType];

    gotoInfoPageAction[strategy](composePath, fileLanguage, infoPage, isAutoColorSchemeShow);
};

const FooterContainer = () => {
    const { t } = useTranslation();
    const [state] = useContext(HeaderContext);
    const { composePath, siteName } = useSiteInfo();
    const [showLicense, setShowLicense] = useState(false);

    const checkDomain = (domain) => {
        const currentDomain = window.location.hostname;
        const regex = new RegExp(`(^|\\.)${domain}$`);
        return regex.test(currentDomain);
    };


    useEffect(() => {
        const isMatched = DomainWithLicenseList.some((domain) => checkDomain(domain));
        setShowLicense(isMatched);
    }, []);

    return (
        <div className="footer__container">
            <div className="footer__nav">
                <div className="logo" role="desktop-visible" />
                {{
                    [SiteMapping.Nova88]: (
                        showLicense && <GameLicense />
                    ),
                }[siteName]}
                <div className="footer__col footer__col--browser" role="desktop-visible">
                    <div className="footer__heading">
                        <span className="text">{t('lbl_SuggestedBrwsr')}</span>
                    </div>
                    {
                        browserItems.map((item) => {
                            return (
                                <div
                                    className="footer__item"
                                    key={item.name}
                                >
                                    <img
                                        src={composePath({
                                            pathType: ServerPath.autoColorscheme,
                                            pathName: `browser/${item.name}.svg`,
                                        })}
                                        alt=""
                                    />
                                </div>
                            );
                        })
                    }
                </div>
                <div className="footer__col footer__col--dropdown">
                    <DropdownButton
                        selectIconName={`icon icon--${state.platform}`}
                        dropdownType="platform"
                        layoutType="footer"
                    />
                    <DropdownButton
                        selectIconName={`flag flag--${state.language}`}
                        dropdownType="language"
                        layoutType="footer"
                    />
                </div>
            </div>
        </div>
    );
};

const FooterNavList = () => {
    const { t } = useTranslation();
    const [state] = useContext(HeaderContext);
    const { composePath, siteName, isAutoColorSchemeShow } = useSiteInfo();

    return (
        <div className="footer__nav-list" role="desktop-visible">
            {
                footerInfoList(siteName).map((row, rowIndex) => {
                    return (
                        <div key={rowIndex} className="footer__nav">
                            {
                                row.map(({ i18nKey, infoPage, openType }) => {
                                    return (
                                        <div
                                            key={i18nKey}
                                            className="footer__item"
                                            onClick={() => handleGoToInfoPageClick(state.language, infoPage, openType, composePath, isAutoColorSchemeShow)}
                                        >
                                            <span className="text">{t(i18nKey)}</span>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    )
                })
            }
        </div>
    );
};

const FooterCopyRightWithLogo = ({ siteName }) => {
    return (
        <div className="footer__cpr">
            <div className="logo" role="mobile-visible" />
            <span className="text">
                <FootText siteName={siteName} />
            </span>
        </div>
    );
};

const FooterCopyRight = ({ siteName }) => {
    return (
        <div className="footer__main">
            <span className="text">
                <FootText siteName={siteName} />
            </span>
        </div>
    );
};

const Footer = () => {
    const { siteName: site, preferredSiteName } = useSiteInfo();
    const siteName = preferredSiteName || site;
    return (
        <ErrorBoundary>
            <div className="footer">
                {
                    {
                        [SiteMapping.Nova88]: (
                            <>
                                <FooterContainer />
                                <FooterNavList />
                                <FooterCopyRightWithLogo siteName={siteName} />
                            </>
                        ),
                        [SiteMapping.IBCBet]: (
                            <>
                                <Footer3rdPartyProvider />
                                <FooterContainer />
                                <FooterCopyRightWithLogo siteName={siteName} />
                            </>
                        ),
                        [SiteMapping.PICA88]: (
                            <>
                                <FooterContainer />
                                <FooterCopyRightWithLogo siteName={siteName} />
                            </>
                        ),
                        [SiteMapping.id8899]: (
                            <>
                                <FooterContainer />
                                <FooterCopyRightWithLogo siteName={siteName} />
                            </>
                        ),
                        [SiteMapping.viva88]: (
                            <FooterCopyRight siteName={siteName} />
                        ),
                        [SiteMapping.bong88]: (
                            <FooterCopyRight siteName={siteName} />
                        ),
                        [SiteMapping.bettha88]: (
                            <>
                                <FooterContainer />
                                <FooterNavList />
                                <FooterCopyRightWithLogo siteName={siteName} />
                            </>
                        ),
                        [SiteMapping.taraPlays]: (
                            <>
                                <FooterContainer />
                                <FooterNavList />
                                <FooterCopyRightWithLogo siteName={siteName} />
                            </>
                        ),
                        [SiteMapping.fifabet]: (
                            <>
                                <FooterCopyRightWithLogo siteName={siteName} />
                            </>
                        ),
                        [SiteMapping.ocean99]: (
                            <>
                                <FooterCopyRightWithLogo siteName={siteName} />
                            </>
                        ),
                    }[siteName]
                }
            </div>
        </ErrorBoundary>
    );
};

export default Footer;
